import { FontEntry } from '../../types/font'

export const robotoFlexTtt: FontEntry = {
  displayName: 'roboto-flex-ttt',
  weights: {},
  variables: {
    normal: {
      file: 'RobotoFlexTTT',
      extension: 'woff2',
      format: 'woff2',
      weightRange: [100, 1000]
    },
    italic: {
      file: 'RobotoSerif-Italic',
      extension: 'woff2',
      format: 'woff2',
      weightRange: [100, 1000]
    }
  }
}
